import styled from 'styled-components';
import { CpBody03Primary } from 'components/atoms/customer-portal/typography';

export const Holygrail = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
  min-height: 800px;
  height: 800px;
  max-height: 1000px;
  width: 100%;
  overflow: hidden;
  border-radius: var(--border-radius-small);
  border: 1px solid var(--cp-border-subtle);
`;

export const Content = styled.div<{ fullWidth?: boolean }>`
  height: 100%;
  min-height: 100%;
  width: ${(props) => (props.fullWidth ? '100%' : 'calc(100% - 300px)')};
  background: var(--cp-white);
  padding: var(--cp-spacing-08);
  padding-top: 0;
  overflow-y: auto;

  @media (max-width: 768px) {
    width: 100%;
    border-radius: var(--border-radius-small);
    border: 1px solid var(--cp-border-subtle);
    padding: var(--cp-spacing-06);
    min-height: 600px;
  }

  @media (max-width: 480px) {
    padding: var(--cp-spacing-03);
  }

  .ant-radio-button-wrapper {
    pointer-events: auto !important;
  }
`;

export const ContentTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: var(--cp-spacing-06);
  position: sticky;
  top: 0;
  padding-top: var(--cp-spacing-08);
  background: var(--cp-white);
  z-index: 100000;

  @media (max-width: 480px) {
    padding-bottom: 0;
    padding-top: 0;
  }
`;

export const ContentTitle = styled(CpBody03Primary)`
  margin-bottom: 0;
  /* ellipsis */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  width: 80%;
  max-width: 80%;
  flex: 1 1 auto;

  @media (max-width: 480px) {
    flex: 1 1 auto;
    white-space: nowrap;
    font-weight: var(--cp-body-02-font-weight);
    font-size: var(--cp-body-02-font-size);
    line-height: var(--cp-body-02-line-height);
    color: var(--cp-text-primary);
    text-decoration-color: var(--cp-text-primary);
  }
`;
